import Item from "./Item";
import './Transaction.css';

const Transaction=(props)=>{//เพิ่ม props
    const {items}=props //เพิ่ม
    return (
      <div>
        <ul className="item-list">
        {items.map((element)=>{//เปลี่ยนจาก data ที่เป็น array object เป็น items ที่ถูกส่งมาจาก app.js
          return <Item {...element} key={element.id}/>
        })}      
        </ul>
      </div>
    );
  }

  export default Transaction;